import { JsonObject, JsonProperty } from "typescript-json-serializer";

@JsonObject()
export class WidgetConfiguration {
    /**
     * The ID or node representing the DOM element containing the widget.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#container)
     */
    @JsonProperty()
    declare container: string | HTMLElement;

    /**
     * Icon which represents the widget.
     *
     * @default null
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#icon)
     */
    @JsonProperty()
    declare icon?: string;

    /**
     * The unique ID assigned to the widget when the widget is created.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#id)
     */
    @JsonProperty()
    declare id: string;

    /**
     * The widget's label.
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#label)
     */
    @JsonProperty()
    declare label: string;
    /**
     * Indicates whether the widget is visible.
     *
     * @default true
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-widgets-Widget.html#visible)
     */
    @JsonProperty()
    declare visible?: boolean;

    constructor() {}
}
